export default "https://assets.pclncdn.com/web/next-landing/8f5502c/_next/static/images/cobrand-topcashback-promo-7ef7dabf7363f6db117e2c0021a467d6.jpg";